(function () {
  'use strict';

  const html = document.documentElement;
  const overlay = document.getElementById('pt-overlay');
  if (!overlay) return;

  if (window.matchMedia('(max-width: 1024px), (prefers-reduced-motion: reduce)').matches) {
    html.classList.remove('pt-animating');
    return;
  }

  const type = overlay.getAttribute('data-pt-type') || '';
  let isNavigating = false;
  let transitionGeneration = 0;

  function getExitDuration() {
    const elements = [overlay, ...overlay.querySelectorAll('*')];
    let duration = 0;

    for (const element of elements) {
      const style = window.getComputedStyle(element);
      const toMilliseconds = (value) => parseFloat(value) * (value.trim().endsWith('ms') ? 1 : 1000);
      const durations = style.transitionDuration.split(',').map(toMilliseconds);
      const delays = style.transitionDelay.split(',').map(toMilliseconds);

      style.transitionProperty.split(',').forEach((property, index) => {
        if (property.trim() === 'none') return;
        const total = durations[index % durations.length] + delays[index % delays.length];
        duration = Math.max(duration, total);
      });
    }

    return duration;
  }

  function navigateAfterExit(url) {
    const generation = ++transitionGeneration;
    overlay.getBoundingClientRect();
    html.classList.add('pt-exiting', 'pt-animating');

    const duration = getExitDuration();
    let navigated = false;
    const navigate = () => {
      if (navigated || generation !== transitionGeneration) return;
      navigated = true;
      clearTimeout(fallback);
      window.location.href = url.href;
    };
    const afterPaint = () => requestAnimationFrame(() => requestAnimationFrame(navigate));
    const fallback = setTimeout(navigate, duration + 250);

    if (typeof overlay.getAnimations !== 'function') {
      setTimeout(afterPaint, duration);
      return;
    }

    const animations = overlay.getAnimations({ subtree: true });
    Promise.allSettled(animations.map((animation) => animation.finished)).then(afterPaint);
  }

  // bfcache restoration: history back/forward may revive a page mid-transition,
  // so make sure the overlay clears.
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;

    transitionGeneration++;
    isNavigating = false;
    html.classList.remove('pt-exiting', 'pt-animating');
    if (typeof overlay.hidePopover === 'function' && overlay.matches(':popover-open')) {
      overlay.hidePopover();
    }
    overlay.removeAttribute('popover');
    try {
      sessionStorage.removeItem('theme-page-transition');
    } catch (_) {}
  });

  document.addEventListener('click', function (e) {
    if (e.button !== 0 || e.defaultPrevented) return;
    if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return;

    const path = typeof e.composedPath === 'function' ? e.composedPath() : null;
    let link = null;
    if (path) {
      for (let i = 0; i < path.length; i++) {
        const node = path[i];
        if (node && node.nodeType === 1 && node.tagName === 'A') {
          link = node;
          break;
        }
        if (node === document) break;
      }
    } else if (e.target && typeof e.target.closest === 'function') {
      link = e.target.closest('a');
    }
    if (!link || !link.href) return;

    if (link.classList.contains('js-back-btn')) return;
    if (link.hasAttribute('download')) return;
    if (link.hasAttribute('data-no-page-transition')) return;
    if (link.target && link.target !== '_self') return;

    let url;
    try {
      url = new URL(link.href, window.location.href);
    } catch (err) {
      return;
    }
    if (url.protocol !== 'http:' && url.protocol !== 'https:') return;
    if (url.origin !== window.location.origin) return;
    if (
      url.pathname === window.location.pathname &&
      url.search === window.location.search &&
      url.hash
    ) {
      return;
    }
    if (url.href === window.location.href) return;

    e.preventDefault();
    if (isNavigating) return;
    isNavigating = true;

    // Promote the overlay into the browser's top layer so it renders ABOVE any
    // already-open modal <dialog> (cart drawer, search, quick-add, zoom, …),
    // which also lives in the top layer. Top-layer ordering is "last added is
    // topmost", so re-adding the overlay now puts it on top of dialogs that
    // were opened earlier. Cart stays visible underneath, the overlay covers
    // it during the exit animation — same behavior as below any other element
    // on the page. z-index can't do this: top layer is above all z-index by
    // spec, so going through showPopover() is the only available promotion.
    if (typeof overlay.showPopover === 'function') {
      try {
        if (!overlay.hasAttribute('popover')) overlay.setAttribute('popover', 'manual');
        if (!overlay.matches(':popover-open')) overlay.showPopover();
      } catch (_) {}
    }

    if (type === 'counter') {
      const el = document.getElementById('pt-counter-val');
      if (el) el.textContent = '0';
    }

    try {
      sessionStorage.setItem('theme-page-transition', 'pending');
    } catch (_) {}

    navigateAfterExit(url);
  });
})();
